/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Přihlásit se k odběru`
};

const da_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Tilmeld dig`
};

const de_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Abonnieren`
};

const en_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Subscribe`
};

const es_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Suscribirse`
};

const fr_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `S'inscrire`
};

const hu_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Regisztráció`
};

const it_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Iscriviti`
};

const nl_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Aanmelden`
};

const pl_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Zapisz się`
};

const pt_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Inscrever-se`
};

const sv_newsletter_footer_subscribe = /** @type {(inputs: {}) => string} */ () => {
	return `Registrera dig`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_footer_subscribe = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_footer_subscribe(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_footer_subscribe", locale)
	if (locale === "cs") return cs_newsletter_footer_subscribe(inputs)
	if (locale === "da") return da_newsletter_footer_subscribe(inputs)
	if (locale === "de") return de_newsletter_footer_subscribe(inputs)
	if (locale === "en") return en_newsletter_footer_subscribe(inputs)
	if (locale === "es") return es_newsletter_footer_subscribe(inputs)
	if (locale === "fr") return fr_newsletter_footer_subscribe(inputs)
	if (locale === "hu") return hu_newsletter_footer_subscribe(inputs)
	if (locale === "it") return it_newsletter_footer_subscribe(inputs)
	if (locale === "nl") return nl_newsletter_footer_subscribe(inputs)
	if (locale === "pl") return pl_newsletter_footer_subscribe(inputs)
	if (locale === "pt") return pt_newsletter_footer_subscribe(inputs)
	return sv_newsletter_footer_subscribe(inputs)
};
export { newsletter_footer_subscribe as "newsletter.footer.subscribe" }